module.exports = __webpack_public_path__ + "static/media/punch-attack.c71000d7.mp3";